import { httpClientSessionManager } from 'dashboard-experience/shared/services'
import { type StoneAccountsResponse } from '../entities'

export const getSessionStoneAccounts = async () => {
  const response = await httpClientSessionManager<StoneAccountsResponse>({
    url: '/api/v1/session-manager/web/account-selector',
    method: 'GET'
  })

  return response.data
}
